module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left-sidebar",
    attrs: {
      "id": "left-sidebar"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "1"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('el-submenu', {
      key: item.index,
      attrs: {
        "index": item.index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), _vm._l((item.options), function(option) {
      return [(option.children && option.children.length) ? _c('el-submenu', {
        key: option.index,
        attrs: {
          "index": option.index
        }
      }, [_c('template', {
        slot: "title"
      }, [_vm._v(_vm._s(option.name))]), _vm._v(" "), _vm._l((option.children), function(child) {
        return _c('el-menu-item', {
          key: child.index,
          attrs: {
            "index": child.index
          }
        }, [_c('router-link', {
          attrs: {
            "to": child.link
          }
        }, [_vm._v(_vm._s(child.name))])], 1)
      })], 2) : _c('el-menu-item', {
        key: option.index,
        attrs: {
          "index": option.index
        }
      }, [_c('router-link', {
        attrs: {
          "to": option.link
        }
      }, [_vm._v(_vm._s(option.name))])], 1)]
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "max": 1
    }
  }, [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "right-iframe",
    attrs: {
      "id": "right-iframe"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "right-iframe",
    attrs: {
      "id": "right-iframe"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0654a5ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/index.vue
// module id = 932
// module chunks = 0